module.exports = __webpack_public_path__ + "static/media/Slide17.18ceb9f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/Slide17.png
// module id = 1639
// module chunks = 0